import Tile from '@atlaskit/tile';
import { token } from '@atlaskit/tokens';
import { cssMap } from '@atlaskit/css';
import { Box, Text, xcss } from '@atlaskit/primitives';
import { useToken } from '../../../../Flow/ConsentContextProvider';

const styles = cssMap({
  image: {
    borderRadius: token('radius.xsmall', '2px'),
    width: '48px',
    paddingRight: token('space.050', '4px'),
  },
});

const initialStyle = xcss({
  font: 'font.heading.xlarge',
});

const Logo = () => {
  const { clientLogoUrl, clientName } = useToken();

  if (clientLogoUrl) {
    return <img src={clientLogoUrl} alt={clientName ?? undefined} css={styles.image} />;
  }

  const initial = (clientName?.trim() || '?').charAt(0).toUpperCase();

  return (
    <Tile
      label={clientName ?? ''}
      size="xlarge"
      backgroundColor="color.background.neutral"
      hasBorder
    >
      <Text weight="bold" color="color.text.subtlest" align="center">
        <Box as="span" xcss={initialStyle}>
          {initial}
        </Box>
      </Text>
    </Tile>
  );
};

export default Logo;
